// src/tracker/pages/FinancialTrackerPage.js

import React from 'react';
import { Box, CssBaseline, Tabs, Tab, Paper, Typography, Stack, Container } from '@mui/material';
import { ThemeProvider } from '../../context/ThemeContext';
import { ConfirmationProvider } from '../../context/ConfirmationContext'; // Import the new Confirmation Provider
import { Outlet, Link, useLocation } from 'react-router-dom';

// This Navigation component is correct and does not need changes
function Navigation() {
    const location = useLocation();
    const currentTab = location.pathname.includes('/history') ? '/Fintracker/history' : '/Fintracker';

    return (
        <Paper
            sx={{
                mb: 3,
                p: { xs: 2, md: 3 },
                borderRadius: 3,
                position: 'sticky',
                top: { xs: 8, md: 16 },
                zIndex: 10,
                backdropFilter: 'blur(10px)',
                background: (theme) =>
                    theme.palette.mode === 'dark'
                        ? 'linear-gradient(135deg, rgba(15, 23, 42, 0.92), rgba(2, 6, 23, 0.92))'
                        : 'linear-gradient(135deg, rgba(255, 255, 255, 0.96), rgba(241, 245, 249, 0.96))',
            }}
        >
            <Stack spacing={2} alignItems="center">
                <Box textAlign="center">
                    <Typography variant="h5">Financial Tracker</Typography>
                    <Typography variant="body2" color="text.secondary">
                        Real-time cashflow, balances, and performance snapshots
                    </Typography>
                </Box>
                <Tabs value={currentTab} centered variant="standard">
                    <Tab label="Dashboard" value="/Fintracker" to="/Fintracker" component={Link} />
                    <Tab label="History" value="/Fintracker/history" to="/Fintracker/history" component={Link} />
                </Tabs>
            </Stack>
        </Paper>
    );
}

const FinancialTrackerPage = () => {
  return (
    <ThemeProvider>
      <ConfirmationProvider>
        <CssBaseline />
        <Box sx={{ minHeight: '100vh', py: { xs: 2, md: 4 } }}>
          <Container maxWidth="xl">
              <Navigation />
              <Outlet /> {/* This correctly renders the child routes from App.js */}
          </Container>
        </Box>
      </ConfirmationProvider>
    </ThemeProvider>
  );
};

export default FinancialTrackerPage;
